module.exports = __webpack_public_path__ + "static/media/wheel.be2e11af.jpg";